module.exports = __webpack_public_path__ + "img/20200423143519437.331b6bc0.png";